<template>
  <section id="livraison">
    <div id="Zone_Widget" ref="relay"></div>
    <!-- Parcelshop code -->
    <input type="hidden" id="PointRelaisSelect" name="PointRelaisSelect" />
    <div class="box" v-show="pointRelais.id">
      <article class="media">
        <div class="media-left">
          <b-icon icon="store-alt" size="is-large"></b-icon>
        </div>
        <div class="media-content">
          <div class="content">
            <p>
              <strong>{{ pointRelais.nom }}</strong>
              <br />
              {{ pointRelais.adresse1 }}
              <br />
              {{ pointRelais.cp + " - " + pointRelais.ville }}
            </p>
            <b-button
              v-if="isMobile()"
              type="is-success is-medium"
              @click="validerPointRelais"
            >
              <b-icon icon="check" />
              <span>Choisir ce point relais</span>
            </b-button>
          </div>
        </div>
        <br />
        <div v-if="!isMobile()" class="buttons">
          <b-button type="is-success is-medium" @click="validerPointRelais">
            <b-icon icon="check" />
            <span>Choisir ce point relais</span>
          </b-button>
        </div>
      </article>
    </div>
  </section>
</template>

<script>
import { auth } from "@/firebase";
import ProfileUser from "@/components/ProfileUser.vue";
const { Profile } = require("../classes/Profile.js");

export default {
  name: "Livraison",
  props: {
    livraisonSelect: Boolean,
    panierIsConfirm: Boolean,
    pointRelais: Object,
  },
  data() {
    return {
      profilIsComplete: false,
    };
  },
  created() {
    this.readData();
    const scriptjQuery = document.createElement("script");
    scriptjQuery.src =
      "//ajax.googleapis.com/ajax/libs/jquery/2.2.4/jquery.min.js";
    document.body.appendChild(scriptjQuery);

    const scriptjLeaflet = document.createElement("script");
    scriptjLeaflet.src = "//unpkg.com/leaflet/dist/leaflet.js";
    document.body.appendChild(scriptjLeaflet);

    const linkLeaflet = document.createElement("link");
    linkLeaflet.src = "//unpkg.com/leaflet/dist/leaflet.css";
    document.body.appendChild(linkLeaflet);

    const scriptRelay = document.createElement("script");
    scriptRelay.src =
      "https://widget.mondialrelay.com/parcelshop-picker/jquery.plugin.mondialrelay.parcelshoppicker.min.js";

    scriptRelay.addEventListener("load", this.loadLivraison);
    document.body.appendChild(scriptRelay);
  },
  computed: {
    adresses() {
      return `${this.pointRelais.adresse1} \n ${this.pointRelais.adresse2}`;
    },
  },
  methods: {
    isMobile() {
      if (
        /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
          navigator.userAgent
        )
      ) {
        return true;
      }
      return false;
    },
    async readData() {
      const profile = new Profile(auth.currentUser.uid);
      await profile.getProfile();
      this.profilIsComplete = profile.profileIsComplete();
    },
    async validerPointRelais() {
      if (this.profilIsComplete) {
        this.$emit("update:livraisonSelect", true);
      } else {
        this.$emit("update:panierIsConfirm", false);
        this.$buefy.dialog.alert({
          title: "Votre profil n'est pas complet.",
          message:
            "Nous avons besoin que vous complétiez votre profil avant de continuer.",
          type: "is-info",
          hasIcon: true,
          icon: "info-circle",
          ariaRole: "alertdialog",
          ariaModal: true,
          confirmText: "Compléter le profil.",
          onConfirm: () => {
            this.$buefy.modal.open({
              parent: this,
              component: ProfileUser,
              onCancel: () => {
                this.$emit("update:panierIsConfirm", true);
                this.readData();
                return;
              },
            });
            return;
          },
        });
      }
    },
    loadLivraison() {
      try {
        $("#Zone_Widget").MR_ParcelShopPicker({
          Responsive: true,
          Target: "#PointRelaisSelect", // Selecteur JQuery de l'élément dans lequel sera renvoyé l'ID du Point Relais sélectionné (généralement un champ input hidden)
          Brand: "CC21ISNC", // Votre code client Mondial Relay
          Country: "FR", // Code ISO 2 lettres du pays utilisé pour la recherche
          AllowedCountries: "FR",
          NbResults: 10,
          OnParcelShopSelected: (data) => {
            this.pointRelais.id = data.ID;
            this.pointRelais.nom = data.Nom;
            this.pointRelais.adresse1 = data.Adresse1;
            this.pointRelais.adresse2 = data.Adresse2;
            this.pointRelais.cp = data.CP;
            this.pointRelais.ville = data.Ville;
            this.pointRelais.pays = data.Pays;
          },
        });
      } catch (error) {
        const scriptjQuery = document.createElement("script");
        scriptjQuery.src =
          "//ajax.googleapis.com/ajax/libs/jquery/2.2.4/jquery.min.js";
        document.body.appendChild(scriptjQuery);

        const scriptjLeaflet = document.createElement("script");
        scriptjLeaflet.src = "//unpkg.com/leaflet/dist/leaflet.js";
        document.body.appendChild(scriptjLeaflet);

        const linkLeaflet = document.createElement("link");
        linkLeaflet.src = "//unpkg.com/leaflet/dist/leaflet.css";
        document.body.appendChild(linkLeaflet);

        const scriptRelay = document.createElement("script");
        scriptRelay.src =
          "https://widget.mondialrelay.com/parcelshop-picker/jquery.plugin.mondialrelay.parcelshoppicker.min.js";

        scriptRelay.addEventListener("load", this.loadLivraison);
        document.body.appendChild(scriptRelay);
      }
    },
  },
};
</script>